import React, { memo } from 'react';
import styled from 'styled-components';
import CountUp from 'react-countup';
import theme from '@styles/theme';

type CountBoxProps = {
    title?: string;
    count?: number;
};

const CountBox = ({ title, count = 0 }: CountBoxProps) => {
    return (
        <Wrapper>
            <Title>{title}</Title>
            <Count start={0} end={count} duration={2} />
        </Wrapper>
    );
};

export default memo(CountBox);

const Wrapper = styled.div`
    flex: 1;
`;
const Title = styled.div`
    ${theme.typography.caption};
    color: ${theme.colors.deepGrayFontColor};
    margin-bottom: 8px;
`;
const Count = styled(CountUp)`
    font-size: 16px;
    font-family: PretendardSemiBold, sans-serif;
`;
